import { createSelector } from 'reselect';
import _ from 'lodash';
import { BOOTH_TYPE } from '../common/Constants';

const RegistrationOrganizerSelector = {
    createSettingDisplayInfoProductSelector: () => createSelector([
        (state) => state.registrationOrganizer.registrationOrganizer.data,
        (state) => state.companyManagementOrganizer.detailCompanyOrganizer.data,
    ], (registration, detailCompany) => {
        if (!_.isEmpty(detailCompany) && detailCompany.user) {
            const { setting_booth } = registration;
            if (setting_booth && detailCompany.user.organizer_booth === BOOTH_TYPE.BIG) {
                return setting_booth.big_zone.settings_display_info_product;
            }

            if (setting_booth && detailCompany.user.organizer_booth === BOOTH_TYPE.STANDARD) {
                return setting_booth.standard_zone.settings_display_info_product;
            }

            if (setting_booth && detailCompany.user.organizer_booth === BOOTH_TYPE.SMALL) {
                return setting_booth.small_zone.settings_display_info_product;
            }

            if (setting_booth && detailCompany.user.organizer_booth === BOOTH_TYPE.GRAND) {
                return setting_booth.grand_zone.settings_display_info_product;
            }
        }
        return {};
    }),
};

export default RegistrationOrganizerSelector;
